import { useState } from 'react';
import { productsAPI } from '../services/api';
import { Button } from './ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { toast } from 'sonner';

export default function StaffAvailability() {
  const [open, setOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [busy, setBusy] = useState(false);
  const [search, setSearch] = useState('');
  const load = async () => {
    setOpen(true); setBusy(true);
    try { setProducts((await productsAPI.getAll()).data); }
    catch { toast.error('Impossible de charger les articles'); }
    finally { setBusy(false); }
  };
  return <>
    <Button variant="outline" onClick={load} className="text-slate-900">Ruptures & disponibilités</Button>
    <Dialog open={open} onOpenChange={setOpen}><DialogContent className="max-h-[85dvh] overflow-y-auto">
      <DialogHeader><DialogTitle>Disponibilité des articles</DialogTitle><DialogDescription>Les articles en rupture sont retirés du menu client.</DialogDescription></DialogHeader>
      <input aria-label="Rechercher un article" type="search" className="rounded-xl border p-3" value={search} onChange={e => setSearch(e.target.value)} placeholder="Rechercher…" />
      {products.filter(p => p.name.toLowerCase().includes(search.toLowerCase())).map(p => <div className="flex items-center justify-between gap-3 border-b py-3" key={p.id}><span>{p.name}</span><Button disabled={busy} variant="outline" onClick={async () => {
        setBusy(true);
        try { await productsAPI.setAvailability(p.id, !p.available); setProducts(prev => prev.map(item => item.id === p.id ? { ...item, available: !p.available } : item)); }
        catch { toast.error('Modification impossible'); } finally { setBusy(false); }
      }}>{p.available ? 'Disponible → Rupture' : 'Rupture → Disponible'}</Button></div>)}
      {busy && <p role="status">Actualisation…</p>}
      {!busy && !products.some(p => p.name.toLowerCase().includes(search.toLowerCase())) && <p className="text-sm text-slate-500">Aucun article trouvé.</p>}
    </DialogContent></Dialog>
  </>;
}
